export const API_KEY = 'AIzaSyArCbTTQXte6Q4lOOmKmXeG-2RSRR3Zvi8';

export default API_KEY;
